import { Box, FormControl, FormLabel, Textarea } from '@mui/joy'
import React from 'react'

function AdvancedEmpfehlungeditor({empfehlung ,setempfehlung, data}) {
    return (
        <>
            <FormControl>
                <FormLabel>Neue Empfehlung</FormLabel>
                <Textarea
                    minRows={15}
                    onChange={(e) => setempfehlung(e.target.value)}
                    value={empfehlung}
                    placeholder="Neue Empfehlung..."
                    variant="outlined"
                />
            </FormControl>
            <FormControl sx={{mt: 2}}>
                <FormLabel>Alte Empfehlung</FormLabel>
                <Textarea sx={{bgcolor: "yellow"}}
                    minRows={15}
                    value={data.lasttarif.empfehlung}
                    placeholder="Alt-Antwort..."
                    variant="outlined"
                />
            </FormControl>


        </>

       
    )
}

export default AdvancedEmpfehlungeditor
